/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, { useEffect, useState } from 'react';

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components
import KPIStudents from './KPIStudents.js';
import KPITeachers from './KPITeachers.js';
import KPISubscription from './KPIStubscription.js';
import KPIGroups from './KPIGroups.js';
import UsageChart from './UsageChart.js';
import Charts from "./Charts.js"
import Tables from "./Tables.js"
import secureLocalStorage from "react-secure-storage";
import './ReportDefault.css'

const ReportDefault = (props) => {
  const [isLoading, setisLoading] = useState(false)
  const [students, setStudents] = useState([])
  const user = JSON.parse(secureLocalStorage.getItem("user"));
  const app = JSON.parse(secureLocalStorage.getItem("app"));    

  return (
    <>
      
      <div className="header bg-ligthgray pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            
            {/* Card stats */}
            <Row className='cards-report'>
              <Col lg="g" xl="3">                
                <KPIStudents></KPIStudents>                
              </Col>
              <Col lg="6" xl="3">
                <KPITeachers></KPITeachers>
              </Col>
              <Col lg="6" xl="3">
                <KPISubscription></KPISubscription>
              </Col>
              <Col lg="6" xl="3">
                <KPIGroups></KPIGroups>
              </Col>
            </Row>

          </div>
        </Container>
      </div>

      {/* Page content */}
      <Container className="mt--7" fluid>

        <UsageChart></UsageChart>

      </Container>
    </>
  );
};

export default ReportDefault;
